import dynamicfunction from '../utils/dynamicfunction';
import { fontSizes } from '../constants/constants';
import { cn } from '../utils/utils';
import { textSizes } from '../config/config';
import { useSelector } from 'react-redux';

const SarSymbol = ({ color, className, size }) => {
  const { TextWeight } = dynamicfunction();

  const fontsize = useSelector((state) => state.content?.fontsize);

  const getSize = () => {
      if (fontsize === textSizes.small) {
        return size ? Number(size) - 2 : 12;
      } else if (fontsize === textSizes.medium) {
        return size ? Number(size) : 14;
      } else if (fontsize === textSizes.large) {
        return size ? Number(size) + 2 : 16;
      }
    };

  return (
    <span style={{ fontFamily: TextWeight.sarSymbol, fontSize: getSize() }} className={cn(color ?? 'text-black', className)}>
      &#xE900;
    </span>
  );
};

export default SarSymbol;
